import { TOUR } from "../ActionTypes"
import { SetFile, CreateModelSuggestion } from "../Tutorial"

const INITIAL_STATE = {
	isOpen: false,
	type: "createproject",
	tour: SetFile
}

const getTypeTour = type => {
	switch (type) {
		case "SetFile": {
			return SetFile
		}
		case "CreateModelSuggestion": {
			return CreateModelSuggestion
		}
		default: {
			return SetFile
		}
	}
}

export default function(state = INITIAL_STATE, action) {
	switch (action.type) {
		case TOUR.OPEN_TOUR: {
			let tour = getTypeTour(action.payload)
			return { ...state, tour, type: action.payload, isOpen: true }
		}
		case TOUR.CLOSE_TOUR: {
			return { ...state, isOpen: false }
		}
		default: {
			return state
		}
	}
}
